export type AdminIdentityCommunicationsTableName =
    `${string}-communications-table`;

export type AdminIdentityMetadataTableName =
    `${string}adminidentity-metadata-table`;

export type AdminIdentityEphemeralTableName =
    `${string}adminidentity-ephemeral-table`;
